import { render, staticRenderFns } from "./FacetItem.vue?vue&type=template&id=45227e89&scoped=true&"
import script from "./FacetItem.vue?vue&type=script&lang=js&"
export * from "./FacetItem.vue?vue&type=script&lang=js&"
import style0 from "./FacetItem.vue?vue&type=style&index=0&id=45227e89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45227e89",
  null
  
)

export default component.exports